import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchLogList = async () => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(`${API_BASE_URL}/log`, config);

  if (!Array.isArray(response.data.log)) {
    throw new Error("예상치 못한 응답 형식");
  }

  return response.data.log;
};

export const fetchAbnormalLogs = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/log-abnormal`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("✅ 이상 알림 로그 응답:", response.data);
    if (response.data.success) {
      return response.data.log_result;
    } else {
      return [];
    }
  } catch (error) {
    console.error("🚨 이상 알림 로그 조회 실패:", error);
    return [];
  }
};

// 응급 알림 발생 및 관리자 처리 이력 조회
export const fetchAlertHistory = async (token) => {
  const response = await axios.get(`${API_BASE_URL}/alert-history`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.data.success || !Array.isArray(response.data.history)) {
    throw new Error(response.data.message || '알림 이력 조회 실패');
  }

  return response.data.history;
};
